"use client";

import ErrorDisplay from "@/components/ErrorDisplay";

export default function DataError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <ErrorDisplay error={error} reset={reset} section="Data" />;
}
